import { render, staticRenderFns } from "./PikadayField.vue?vue&type=template&id=3f1b716f&scoped=true"
import script from "./PikadayField.vue?vue&type=script&lang=ts"
export * from "./PikadayField.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f1b716f",
  null
  
)

export default component.exports